/**
 * WhySmsTour - A data-driven walkthrough convincing insurance agency owners
 * why SMS is the most effective client communication channel.
 *
 * This tour is entirely modal-based — no navigation or element highlighting.
 */

import type { TourStep } from '../types';

export type WhySmsTourStepId = 'why_sms';

export const WHY_SMS_TOUR_STEPS: TourStep[] = [
  {
    id: 'why_sms',
    type: 'modal',
    title: '',
    content: '',
  },
];
